import { useMutation, useQueryClient } from '@tanstack/react-query'
import { profileService } from '@/services/profileService'
import { toast } from '@/stores/toastStore'
import { useAuth } from '@/stores/authStore'

/**
 * Hook to update current user's username
 */
export function useUpdateUsername() {
  const queryClient = useQueryClient()
  const { user, updateUser } = useAuth()

  return useMutation({
    mutationFn: (username: string) => profileService.updateUsername(username),
    onSuccess: (_, username) => {
      // Update user in auth store immediately
      if (user) {
        updateUser({
          ...user,
          username,
        })
      }
      // Also invalidate current user query to refetch updated data
      queryClient.invalidateQueries({ queryKey: ['currentUser'] })
      toast.success('Username updated successfully!')
    },
    onError: (error: any) => {
      // Don't show error if API endpoint doesn't exist yet (404/500)
      const status = error.response?.status
      if (status && status !== 404 && status !== 500 && status !== 501) {
        const message =
          error.response?.data?.message || 'Failed to update username'
        toast.error(message)
      }
      console.error('Username update error:', error)
    },
  })
}
